<template>
  <footer class="footer" :class="{ [`footer-${type}`]: type }" :data-background-color="backgroundColor">
    <div class="container fluid">
      <div class="mx-auto" style="max-width: 100%; text-align: center;">
        <div class="copyright">
        Copyright Romida Automation S.A de C.V, &copy; {{ year }}
        </div>
      </div>
      
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
